import { connect } from 'react-redux';
import noop from 'lodash/noop';

import {
  showErrorNotification
} from 'zoomforth_codesbane_editor/action_creators/misc.js';

import ImageCropperWithSrcSigner from './image_cropper_with_src_signer.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, { onSuccess, onCancel=noop, onFail=noop }) => ({
    onCancel: ()=> {
      dispatch(closeModal());
      onCancel();
    },
    onCrop: (zfImage)=> { 
      onSuccess(zfImage);
      dispatch(closeModal());
    },
    onCropFail: (message)=> {
      dispatch(showErrorNotification(
        'Cropping failed',
        `Image cropping failed with the error "${message}".  Please try again and contact support if the problem persists.`
      ));
      onFail();
    }
  }
);

const ImageCropperModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageCropperWithSrcSigner);

ImageCropperModal.editorModalName = 'ImageCropperModal';

export default ImageCropperModal;
